import debug from 'debug'
import request from '../../domain/utils/request'
import { getService } from '../../parameters'
import SERVICES from '../../services.constants'

const dSeo = debug('seo')

const handleSeoCatch = context => e => {
  if (e?.response?.status === 404) {
    if (dSeo.enabled) {
      dSeo(`fetch seo: 404 on ${context}`)
    }
  } else {
    console.error(`fetch error on ${context}`, e)
  }
  return {}
}

export const fetchSeoLinks = path => {
  if (!path) return Promise.reject(new Error('missing route'))

  const serviceUrl = getService(SERVICES.WEB_SEO_LINKS, path)

  return request
    .get(serviceUrl, { silent: true })
    .then(({ data }) => data)
    .catch(handleSeoCatch(`${SERVICES.WEB_SEO_LINKS} ${path}`))
}
